'use client';

import { useMemo, useRef, useState } from 'react';
import { ListingsSlider } from '@/features/listings/components/ListingsSlider';
import { cn } from '@/shadcn/lib/utils';

type VisibleOffers = 'sale' | 'rent' | 'demand';

export function AgencyOffers() {
    const [visibleOffers, setVisibleOffers] = useState<VisibleOffers>('sale');

    const BUTTONS = useMemo(() => {
        return [
            { key: 'sale', text: 'Predaj', onClick: () => {} },
            { key: 'rent', text: 'Prenájom', onClick: () => {} },
            { key: 'demand', text: 'Dopyt', onClick: () => {} },
        ];
    }, []);

    return (
        <div className="">
            <div className="my-[12px] flex gap-[10px] justify-center lg:justify-start">
                {BUTTONS.map((button, i) => {
                    return (
                        <a
                            key={i}
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                button.onClick();
                            }}
                            className={cn(
                                'py-[8px] px-[25px] bg-[#f3f3f3] rounded-[30px] font-[600] text-[13px]',
                                'lg:text-[14px] lg:py-[10px]',
                                visibleOffers === button.key && 'bg-cust-primary',
                            )}
                        >
                            {button.text}
                        </a>
                    );
                })}
            </div>
            <div className="">
                <ListingsSlider maxSlidesPerView={4} background="grey" listings={[]} />
            </div>
        </div>
    );
}
